export const REPORTREGISTEREDTIME_SEARCH = 'REPORTREGISTEREDTIME_SEARCH';
export const REPORTREGISTEREDTIME_PAGE = 'REPORTREGISTEREDTIME_PAGE';
export const REPORTREGISTEREDTIME_YEAR = 'REPORTREGISTEREDTIME_YEAR';
export const REPORTREGISTEREDTIME_WORKTYPE = 'REPORTREGISTEREDTIME_WORKTYPE';
export const REPORTREGISTEREDTIME_USERID = 'REPORTREGISTEREDTIME_USERID';
export const REPORTREGISTEREDTIME_COMPANY = 'REPORTREGISTEREDTIME_COMPANY';
